import { GrUser } from 'react-icons/gr';
import { HiDocumentReport } from 'react-icons/hi';
import { TbReportAnalytics } from 'react-icons/tb';
import { TbReport } from 'react-icons/tb';
import { RenderTiles } from '../../components/common';
import ChildHeader from '../../components/ui/ChildHeader';
const tiles = [
  {
    sNo: 3,
    link: '/common/masterListOfVendor',
    isLink: true,
    icon: <GrUser size="5rem" color="#064a29" />,
    p: 'MASTER LIST OF',
    span: 'VENDOR',
    isIcon: true,
  },
  {
    sNo: 3,
    link: '/common/riDepartment/inspectionReportList',
    isLink: true,
    icon: <TbReportAnalytics size="5rem" color="#343a40" />,
    p: 'Inspection',
    span: 'Report',
    isIcon: true,
  },
  // {
  //   sNo: 1,
  //   link: '/common/riPart',
  //   isLink: true,
  //   icon: <HiDocumentReport size="5rem" color="#003566" />,
  //   p: 'RI PART',
  //   span: 'LIST',
  //   isIcon: true,
  // },
  // {
  //   sNo: 4,
  //   link: `/common/inspectionStandardList`,
  //   isLink: true,
  //   icon: <TbReport size="5rem" color="#a12222" />,
  //   p: 'INSPECTION',
  //   span: 'STANDARD',
  //   isIcon: true,
  // },
  // {
  //   sNo: 4,
  //   link: `/common/vendorDocumentList`,
  //   isLink: true,
  //   icon: <TbReport size="5rem" color="#a12222" />,
  //   p: 'SUPPLIER',
  //   span: 'DOCUMENTS',
  //   isIcon: true,
  // },

  // {
  //   sNo: 5,
  //   link: `/common/inspectionReportList`,
  //   isLink: true,
  //   icon: <TbReportAnalytics size="5rem" color="#a12222" />,
  //   p: 'INCOMING INSPECTION',
  //   span: 'Report',
  //   isIcon: true,
  // },
  // {
  //   sNo: 6,
  //   link: `/common/supplierComplaintRegister`,
  //   isLink: true,
  //   icon: <GrUser size="5rem" color="#003566" />,
  //   p: 'SUPPLIER COMPLAINT',
  //   span: 'REGISTER',
  //   isIcon: true,
  // },
  // {
  //   sNo: 7,
  //   link: `/common/riDocumentUpload/?documentType=iaiSSTPlan`,
  //   isLink: true,
  //   icon: <HiDocumentReport size="5rem" color="#003566" />,
  //   p: 'IAI SST',
  //   span: 'PLAN',
  //   isIcon: true,
  // },
  // {
  //   sNo: 8,
  //   link: `/common/riDocumentUpload/?documentType=iaiMtcPlanList`,
  //   isLink: true,
  //   icon: <HiDocumentReport size="5rem" color="#003566" />,
  //   p: 'IAI MTC',
  //   span: 'PLAN',
  //   isIcon: true,
  // },
  // {
  //   sNo: 9,
  //   link: `/common/riDocumentUpload/?documentType=riDocuments`,
  //   isLink: true,
  //   icon: <HiDocumentReport size="5rem" color="#003566" />,
  //   p: 'RI',
  //   span: 'DOCUMENTS',
  //   isIcon: true,
  // },
];

const RIDeparment = () => {
  return (
    <>
      <ChildHeader text="RI DEPARTMENT" />
      <RenderTiles
        height="100vh"
        tilesObj={tiles}
        justify="start"
        columns="0fr"
      />
    </>
  );
};

export default RIDeparment;
